const url = "https://disaster-backend-cors.vercel.app"


export { url }